<template>
  <div class="w-100">
    <div class="styles-result-header">
      {{ $resourceString["site.search.styles.result.header"] }}
    </div>
    <div class="row w-100">
      <div
        class="col-2"
        v-for="item in safeProducts.slice(0, 4)"
        :key="item.styleNumber"
      >
        <div class="d-block">
          <a class = "text-decoration-none"
            :href="
              $helpers.getProductDetailUrl(
                item.styleNameURL,
                item.styleNumber,
                item.colors[0].colorNumber
              )"
          >
            <wf-load-image
              :wrapperClass="'w-100 styles-image'"
              :imageClass="'image w-100'"
              :src="item.colors[0].imagePath"
              :alt="item.styleName"
              :noImageStyles="'no-image-style-block'"
            />
          </a>
        </div>
        <ul class="styles-list">
          <li v-html="$helpers.matchText(item.styleName, searchTerm)"></li>
          <li>{{ item.productActualSize }} </li>
          <li
            v-if="item.colors[0].colorName && item.colors[0].colorNumber"
            v-html="
              $helpers.matchText(
                `${item.colors[0].colorName} - ${item.colors[0].colorNumber}`,
                searchTerm
              )
            "
          />
          <li v-else>
            {{ item.itemsCount }}
            {{ $resourceString["site.search.products.result.color.list"] }}
          </li>
        </ul>
        <div class="mt-auto">
          <a 
            :href="
              $helpers.getProductDetailUrl(
                item.styleNameURL,
                item.styleNumber,
                item.colors[0].colorNumber
              )
            "
            class="view-styles-link cart-item-model-no"
            >{{ $resourceString["site.search.products.result.view.style"] }}</a
          >
          <Icon class="mb-1" icon="bx:bx-right-arrow-alt" width="15" />
        </div>
      </div>
      <div class="col-2 ">
        <a
          :href="$helpers.getSearchTermUrl(searchTerm, 'styles')"
          v-if="products.length > 4"
        >
          <div class="view-more">
            <div class="view-more-text">
              {{ $resourceString["site.search.products.result.view.more"] }}
              <Icon
                class="pb-1 pl-1"
                icon="fa-solid:plus"
                color="white"
                width="20"
              />
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WFLoadImage from "../wf-load-image.vue";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    "wf-load-image": WFLoadImage,
    Icon
  },
  props: ["products"],
  computed: {
    ...mapGetters({
      searchTerm: "searchMenu/searchTerm"
    }),
    safeProducts() {
      return this.products.map(product => ({
        ...product,
        colors: product.colors && product.colors.length > 0 ? product.colors : [{ colorNumber: ""}]
      }));
    }
  }
};
</script>
